import { apiClient } from '../api';

export const integrationsApi = {
  // { integrations: [...], model_order, ai_policy, secrets_key_set }
  async overview() {
    const { data } = await apiClient.get('/api/integrations/overview');
    return data;
  },

  async get(provider) {
    const { data } = await apiClient.get(`/api/integrations/${provider}`);
    return data.integration;
  },

  // A blank api_key keeps the saved one.
  async save(provider, config, enabled = true) {
    const { data } = await apiClient.put(`/api/integrations/${provider}`, { config, enabled });
    return data;
  },

  async testOllama(url) {
    const { data } = await apiClient.post('/api/integrations/ollama/test', { url });
    return data;
  },

  async testClaude(apiKey, model) {
    const { data } = await apiClient.post('/api/integrations/claude/test', { api_key: apiKey, model });
    return data;
  },

  async aiPolicy() {
    const { data } = await apiClient.get('/api/ai/policy');
    return data;
  },

  // Tokens and an estimated cost per model: { days, totals, by_model, by_feature, daily, month_to_date }
  async aiUsage(days = 30) {
    const { data } = await apiClient.get('/api/ai/usage', { params: { days } });
    return data;
  },

  async setAiPolicy(patch) {
    const { data } = await apiClient.put('/api/ai/policy', patch);
    return data;
  },
};
